import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { getAllAilmentApi } from "services/getApis";

const SelectAilment = ({ onContinue }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedAilment, setSelectedAilment] = useState({ id: "", name: "" });

  //Get All Ailment Api Call
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["getAilment"],
    queryFn: getAllAilmentApi,
    retry: 3,
  });

  const ailments = useMemo(() => data?.payload, [data]);

  const handleAilmentSelect = (ailment) => {
    console.log("Ailment select", ailment);
    setSelectedAilment(ailment);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleContinue = () => {
    onContinue?.(selectedAilment?.id);
  };

  return (
    <>
      <h2 className="question-title">Select Ailment</h2>

      <div className="ailment-dropdown">
        <div className="custom-dropdown">
          <div
            className={`dropdown-header ${isDropdownOpen ? "open" : ""}`}
            onClick={toggleDropdown}
          >
            <span className="dropdown-text">
              {selectedAilment?.name || "Choose an ailment..."}
            </span>
            <svg
              className={`dropdown-arrow ${isDropdownOpen ? "rotated" : ""}`}
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M6 9L12 15L18 9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {isDropdownOpen && (
            <div className="dropdown-list">
              {isLoading && isFetching ? (
                <div className="d-flex  justify-content-center  my-3">
                  <Spinner animation="border" />
                </div>
              ) : (
                ailments?.map((ailment) => (
                  <div
                    key={ailment?.id}
                    className={`dropdown-item ${
                      selectedAilment?.id === ailment?.id ? "selected" : ""
                    }`}
                    onClick={() => handleAilmentSelect(ailment)}
                  >
                    {ailment?.name}
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>

      <button
        className={`continue-btn ${
          selectedAilment?.id ? "active" : "disabled"
        }`}
        onClick={handleContinue}
        disabled={!selectedAilment?.id}
      >
        Continue
      </button>
    </>
  );
};

export default SelectAilment;
